import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAccessibility } from '../../../../Store/contexts/AccessibilityContext';
import { sxDarkGreyBody } from '../../../../assets/styles/CommonSxProps';
import DefaultButton from '../../../../components/Accessibility/DefaultButton';
import DefaultTextBold from '../../../../components/Accessibility/DefaultTextBold';
import PageTitle from '../../../../components/Accessibility/PageTitle';
import ChatCard from '../../../../components/ChatComEquipe/ChatCard';
import { ChatTypeEnum } from '../../../../components/ChatComEquipe/ChatTypeEnum';
import LoadingApp from '../../../../components/LoadingApp';
import ModalFeedBack from '../../../../components/ModalFeedBack';
import { Mensagem as Conversa } from '../../../../interfaces/entities/SaudeBemEstar/ChatComEquipeGC/Mensagem';
import { getConversasPersonal } from '../../../../services/PlanoMaisService';
import './styles.css';
import { sxGreenTextButton } from './sxProps';

const ConversasPersonal: React.FC = () => {

  const [loading, setLoading] = useState<boolean>(false);
  const [modalFeedback, setModalFeedback] = useState<null | {
    icon?: 'error' | 'success' | 'warning', title?: string, textButton?: string, subTitle?: string,
    closeAction: () => void, showButtonModal: boolean, buttonAction?: () => void
  }>(null);
  const [conversasAbertas, setConversasAbertas] = useState<Conversa[]>([]);
  const [conversasConcluidas, setConversasConcluidas] = useState<Conversa[]>([]);
  const navigate = useNavigate();

  const accessibility = useAccessibility();

  const fetchConversas = async () => {
    setLoading(true);
    const response = await getConversasPersonal();
    if (response?.status === 200) {
      const conversas: Conversa[] = response.data;
      const conversasAbertas: Conversa[] = [];
      const conversasConcluidas: Conversa[] = [];
      conversas.forEach(conversa => {
        if (conversa.status === 'MP') {
          conversasAbertas.push(conversa);
        } else if (conversa.status === 'MF') {
          conversasConcluidas.push(conversa);
        }
      });
      setConversasAbertas(conversasAbertas);
      setConversasConcluidas(conversasConcluidas);
    } else {
      console.error(response);
      handleFetchConversationsError();
    }
    setLoading(false);
  }

  const handleFetchConversationsError = () => {
    openModal('error', 'Erro', 'Ocorreu um erro ao buscar as conversas. Tente novamente mais tarde.',
      'Fechar', () => window.history.back(), () => window.history.back());
  }

  useEffect(() => {
    fetchConversas();
  }, []);

  const openModal = (
    icon: 'success' | 'warning' | 'error', title: string, subTitle: string, textButton: string, closeAction: () => void, buttonAction: () => void
  ) => {
    setModalFeedback({
      icon,
      title,
      subTitle,
      textButton,
      showButtonModal: true,
      closeAction: closeAction,
      buttonAction: buttonAction
    });
  }

  return (
    <>
      <LoadingApp showLoading={loading} text='Carregando...' />
      {!loading &&
        <div className='chat-infos-container'>
          <PageTitle text='Fale com o personal' />

          <Typography
            sx={sxDarkGreyBody} style={accessibility.textStyleAccessibility}
          >
            Converse com sua equipe de saúde de referência do Espaço Personal.
          </Typography>

          {(conversasAbertas.length === 0 && conversasConcluidas.length === 0) &&
            <Typography
              sx={sxDarkGreyBody} style={accessibility.textStyleAccessibility} tabIndex={0}
            >
              Você não tem nenhuma mensagem.
            </Typography>
          }

          {conversasAbertas?.length > 0 && <ChatCard conversa={conversasAbertas[0]} chatType={ChatTypeEnum.PERSONAL} />}

          <div className='chat-buttons-container'>
            <DefaultButton text='Iniciar nova conversa' onClick={() => navigate('/saudeOnline/faleComPersonal/conversaEquipe/conversas/nova')} />
            {conversasAbertas.length > 1 &&
              <DefaultButton
                variant='text' sx={sxGreenTextButton}
                style={accessibility.textStyleAccessibility}
                onClick={() => navigate('/saudeOnline/faleComPersonal/conversaEquipe/conversas/abertas')}

              >
                <u>ver todas as conversas em andamento</u>&nbsp;&nbsp;<FontAwesomeIcon icon={faChevronRight} />
              </DefaultButton>
            }
          </div>

          {conversasConcluidas.length > 0 &&
            <>
              <DefaultTextBold text='Histórico de conversas concluídas' large component='h2' />
              {conversasConcluidas.slice(0, 5).map((conversa, index) => (
                <ChatCard key={index} conversa={conversa} chatType={ChatTypeEnum.PERSONAL} />
              )
              )}
              {conversasConcluidas.length > 5 &&
                <DefaultButton
                  variant='text' sx={sxGreenTextButton}
                  style={accessibility.textStyleAccessibility}
                  onClick={() => navigate('/saudeOnline/faleComPersonal/conversaEquipe/conversas/concluidas')}
                >
                  <u>ver todas as conversas concluídas</u>&nbsp;&nbsp;<FontAwesomeIcon icon={faChevronRight} />
                </DefaultButton>
              }
            </>
          }
        </div >
      }
      <ModalFeedBack
        showModal={!!modalFeedback}
        handleShowModal={modalFeedback?.closeAction}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        icon={modalFeedback?.icon as 'success' | 'error' | 'warning'}
        showButtonModal={modalFeedback?.showButtonModal}
        textButton={modalFeedback?.textButton as string}
        handleButtonModal={modalFeedback?.buttonAction}
      />
    </>
  )
}

export default ConversasPersonal;